import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";

import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import Routing from "@/pages/Routing";
import Rolloff from "@/pages/Rolloff";
import Dispatch from "@/pages/Dispatch";
import Billing from "@/pages/Billing";
import Fleet from "@/pages/Fleet";
import RouteSequencing from "@/pages/RouteSequencing";
import PaymentRecovery from "@/pages/PaymentRecovery";
import Carts from "@/pages/Carts";
import Inventory from "@/pages/Inventory";
import Communications from "@/pages/Communications";
import Reports from "@/pages/Reports";
import FeatureRequests from "@/pages/FeatureRequests";
import Settings from "@/pages/Settings";
import SignupWizard from "@/pages/SignupWizard";
import PortalDashboard from "@/pages/PortalDashboard";
import Driver from "@/pages/Driver";
import EmbedGenerator from "@/pages/EmbedGenerator";
import EmbedSignup from "@/pages/EmbedSignup";
import Leads from "@/pages/Leads";
import ServiceArea from "@/pages/ServiceArea";
import Users from "@/pages/Users";
import SecurityActivity from "@/pages/SecurityActivity";
import ARAging from "@/pages/ARAging";
import Holidays from "@/pages/Holidays";
import AuditLog from "@/pages/AuditLog";
import Expenses from "@/pages/Expenses";
import Profitability from "@/pages/Profitability";
import TemplatesPage from "@/pages/TemplatesPage";
import SalesTaxReportPage from "@/pages/SalesTaxReportPage";
import AgreementSignPage from "@/pages/AgreementSignPage";
import Timesheets from "@/pages/Timesheets";
import PaySuccess from "@/pages/PaySuccess";
import InvoicePay from "@/pages/InvoicePay";
import SignupThanks from "@/pages/SignupThanks";

import "@/App.css";
import { BrandingGate } from "@/lib/branding";

export default function App() {
    return (
        <ThemeProvider>
            <BrandingGate>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<SignupWizard />} />
                        <Route path="/signup/thanks" element={<SignupThanks />} />
                        <Route path="/portal" element={<PortalDashboard />} />
                    <Route path="/agreement/sign/:token" element={<AgreementSignPage />} />
                        <Route path="/portal/login" element={<PortalDashboard />} />
                        <Route path="/portal/invoices" element={<PortalDashboard />} />
                        <Route path="/driver" element={<Driver />} />
                        <Route path="/embed/signup" element={<EmbedSignup />} />
                        <Route path="/pay/success" element={<PaySuccess />} />
                        <Route path="/pay/:invoiceId" element={<InvoicePay />} />

                        {/* Authenticated operations console */}
                        <Route element={<AppLayout />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/customers" element={<Customers />} />
                            <Route path="/leads" element={<Leads />} />
                            <Route path="/service-area" element={<ServiceArea />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/security" element={<SecurityActivity />} />
                            <Route path="/timesheets" element={<Timesheets />} />
                            <Route path="/routing" element={<Routing />} />
                            <Route path="/rolloff" element={<Rolloff />} />
                            <Route path="/dispatch" element={<Dispatch />} />
                            <Route path="/billing" element={<Billing />} />
                            <Route path="/ar-aging" element={<ARAging />} />
                            <Route path="/holidays" element={<Holidays />} />
                            <Route path="/fleet" element={<Fleet />} />
                            <Route path="/sequencing" element={<RouteSequencing />} />
                            <Route path="/payment-recovery" element={<PaymentRecovery />} />
                            <Route path="/carts" element={<Carts />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/communications" element={<Communications />} />
                            <Route path="/communications/templates" element={<TemplatesPage />} />
                            <Route path="/reports" element={<Reports />} />
                            <Route path="/reports/sales-tax" element={<SalesTaxReportPage />} />
                            <Route path="/feature-requests" element={<FeatureRequests />} />
                            <Route path="/expenses" element={<Expenses />} />
                            <Route path="/profitability" element={<Profitability />} />
                            <Route path="/audit" element={<AuditLog />} />
                            <Route path="/embed" element={<EmbedGenerator />} />
                            <Route path="/settings" element={<Settings />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
            </BrandingGate>
        </ThemeProvider>
    );
}
